/**
 * The Feedback panel's open state lives in each layout, so anything outside a layout (the modal
 * launcher) asks it to open through a window event rather than a shared store.
 */
export const OPEN_FEEDBACK_EVENT = 'harmony:open-feedback';

export function requestOpenFeedback(): void {
  window.dispatchEvent(new Event(OPEN_FEEDBACK_EVENT));
}
